import { DployTheme } from "../dployTheme";
import * as element from "./element";
import { Theme, createTheme, ThemeOptions } from "@material-ui/core/styles";
import { internal } from "./element-internal";

export const name = "Element (dense)";
export const id = "element_dense";

export const muiTheme = (theme: Theme): Theme => {
	theme = createTheme({
		...element.muiTheme(theme),
		typography: {
			fontSize: 12,
			h1: {
				fontSize: "2.5rem"
			},
			h2: {
				fontSize: "2rem"
			},
			h3: {
				fontSize: "1.75rem"
			},
			h4: {
				fontSize: "1.5rem"
			},
			h5: {
				fontSize: "1.25rem"
			},
			h6: {
				fontSize: "1rem"
			}
		},
		breakpoints: {
			values: {
				xs: 400,
				sm: 450,
				md: 768,
				lg: 960,
				xl: 1280
			}
		},
		spacing: 6,
		props: {
			MuiTextField: { size: "small" }
		}
	});

	return createTheme(theme, dense(theme));
};
export const dense = (theme: DployTheme): ThemeOptions => {
	const element = internal(theme);
	return {
		...element,
		overrides: {
			...element.overrides,
			DployFormLiteral: {
				root: {
					fontSize: 14,
					lineHeight: 1
				}
			}
		}
	};
};
